/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./VIPRDecoratable',
	'./VIPRFormatter',
	'../../../widgets/livewidget/nls/StringResources'
], function(_, VIPRDecoratable, VIPRFormatter, StringResources) {

	// implements IItem
	class VIPRItem extends VIPRDecoratable {
		constructor(item, context, content) {
			super(item, context);

			this.item = item;
			this.content = content;
			this.context = context;
			this._tuples = [];
			this.dataset = context.dataset;
			this._recalculateFormattedValue();
			this.dataset = context.dataset;

		}

		destroy() {
			this.context = null;
			this.dataset = null;
			this._datapoints = null;
			this._tuples = null;
		}
		/**
		 * We are checking here if the aggregateTypeVisible toggler is on/off for multiMeasures
		 * Regardless of the formatted string, this unformattedValue will remain constant which allows usage such as color consistency (fred is red)
		 */
		_recalculateFormattedValue() {
			const formatter = new VIPRFormatter(this.context.index.dataitem, this.context.index.tupleitem, this.context);
			if (this.item.value === undefined || this.item.label === null) {
				this.formattedValue = formatter.format(null);
				this.unformattedValue = this.formattedValue;
			} else if (this.item.aggregate) {
				let aggregateTypeVisible = !!(this.content.getPropertyValue('widget.legend.aggregateTypeVisible'));
				if (aggregateTypeVisible) {
					this.formattedValue = formatter.format(StringResources.get('multiMeasureLabel',{ 'measureName':this.item.label.toString(),'aggregate':StringResources.get(this.item.aggregate.toString()) }));
					this.unformattedValue = this.item.label + this.item.aggregate;
				} else {
					this.formattedValue = formatter.format(StringResources.get('measureLabel',{ 'measureName':this.item.label.toString() }));
					this.unformattedValue = this.item.label + this.item.aggregate;
				}
			} else {
				this.formattedValue = formatter.format(this.item.label.toString());
				this.unformattedValue = this.item.label;
			}
		}

		addTuple(tuple) {
			this._tuples.push(tuple);
			this._datapoints = null;
		}

		get datapoints() {
			if ( !this._datapoints ) {
				this._datapoints = [];
				for ( let i = 0; i < this._tuples.length; i++ ) {
					const tuple = this._tuples[i];
					for ( let j = 0; j < tuple.datapoints.length; j++ ) {
						this._datapoints.push(tuple.datapoints[j]);
					}
				}
			}
			return this._datapoints;
		}

		getUniqueName() {
			return (this.item.value === undefined || this.item.value === null) ? this.item.value : this.item.value.toString();
		}

		getCaption() {
			if ( this.item.aggregate ) {
				const currentAggregationPropertyValue = this.content.getPropertyValue('widget.legend.aggregateTypeVisible');
				if (currentAggregationPropertyValue != this.aggregationPropertyValue) {
					this._recalculateFormattedValue();
					this.aggregationPropertyValue = currentAggregationPropertyValue;
				}
			}
			if ( !this.formattedValue ) {
				this._recalculateFormattedValue();
			}
			return this.formattedValue;
		}

		getParent() {
			return this.item.p;
		}

		decorate(action, value) {
			super.decorate(...arguments);
			const datapoints = this.datapoints;
			if (datapoints.length > 0) {
				this.context.version++;
				// decorate the datapoints
				for ( let i = 0; i < datapoints.length; i++ ) {
					datapoints[i].decorate(action, value);
				}
			}
		}
	}

	return VIPRItem;
});